import { Dept } from '../../model/tenant/dept';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonUtil } from '../util/json.util';
import { map } from 'rxjs/operators';
import { NecUrl } from '../../model/url/url';
import { Observable } from 'rxjs';


@Injectable()
export class NecDeptInterface {
  constructor(private http: HttpClient) {
  }

  /**
   * è·åå¨éé¨é¨ä¿¡æ¯
   */
  getDeptsByTenantId(tenantId: number): Observable<Dept[]> {
    return this.http.get<Dept[]>(NecUrl.SERVER_URL + '/server/tenants/' + tenantId + '/depts')
      .pipe(map((depts) => JsonUtil.jsonConvert(depts, Dept)));
  }

  /**
   * è·åç¨æ·è¢«å®ä¹ä¸ºç®¡çåçç§å®¤åè¡¨
   */
  getDefinedDeptsByUserId(userId: number): Observable<Dept[]> {
    return this.http.get<Dept[]>(NecUrl.SERVER_URL + '/server/adminDepts?type=defined&userId=' + userId)
      .pipe(map((depts) => JsonUtil.jsonConvert(depts, Dept)));
  }
}
